import React from 'react';
import styled from 'styled-components';
import { FocusStylesInverted } from '../../styles/FocusStyles';
import { media } from '../themes/theme';
import { ContactIcon } from './Icons';
const Link = styled.a `
  color: ${props => props.theme.White};
  text-decoration: none;
  display: flex;
  align-items: center;
  font-size: 1rem;

  :hover {
    text-decoration: underline;
  }

  ${media.laptop `
    font-size: .875rem;
  `}

  ${FocusStylesInverted};
`;
const StyledContactIcon = styled(ContactIcon) `
  margin-right: 0.875rem;
  width: 2.25rem;
`;
export const ContactLink = ({ children, className = undefined, dataTestId = undefined, to, onClick = undefined, }) => (React.createElement(Link, { "data-testid": dataTestId, className: className, href: to, onClick: onClick },
    React.createElement(StyledContactIcon, null),
    children));
